<script lang="ts" setup>
import type { SectionWithIndex } from '~/types'

interface Props extends Pick<SectionWithIndex, 'title' | 'theme' | 'subtitle' | 'expand' | 'buttons' | 'description' | 'optionJson'> { }
const props = defineProps<Props>()
</script>

<template>
  <section
    class="gap-6 my-32 py-40 lg:py-64 px-6 md:px-10 lg:px-16 2xl:px-32 w-11/12 xl:w-10/12 flex flex-wrap items-center  relative"
  >
    <div class="w-full lg:flex-1">
      <div
        v-motion
        class="subtitle font-display font-bold uppercase text-2xl md:text-4xl lg:text-5xl xl:text-6xl"
        :visible="{ opacity: 1, rotate: 0, y: 0, x: 0, scale: 1 }"
        :initial="{ opacity: 0, rotate: 5, x: 20, scale: 0.5 }"
        :delay="100"
      >
        {{ props.subtitle }}
      </div>
      <HeadingText
        v-motion
        :visible="{ opacity: 1, rotate: 0, y: 0, x: 0, scale: 1 }"
        :initial="{ opacity: 0, rotate: 5, x: 20, scale: 0.5 }"
        :delay="350"
        tag="h2"
        class="mb-6 heading"
        :class="'text-'+theme"
      >
        {{ props.title }}
      </HeadingText>
      <div
        class="htmldescription pb-12  max-w-4xl"
        data-allow-mismatch
        v-html="props.description"
      />
      <PageButtons
        v-if="buttons?.length"
        :buttons="expand?.buttons"
        class="pt-3 md:pt-6 lg:pt-12"
        :background="theme"
      />
    </div>
    <div class="w-full flex-1">
      <UAccordion
        color="primary"
        size="2xl"
        :items="optionJson"
      >
        <template #default="{ item, index, open }">
          <UButton
            color="blue"
            class="mb-2"
            :ui="{ rounded: 'rounded', padding: { sm: 'p-3' } }"
          >
            <span class="text-xl text-left px-2">{{ item.label }}</span>

            <template #trailing>
              <UIcon
                name="i-heroicons-chevron-right-20-solid"
                class="w-5 h-5 ms-auto transform transition-transform duration-200"
                :class="[open && 'rotate-90']"
              />
            </template>
          </UButton>
        </template>
        <template #item="{ item }">
          <p class="text-lg">
            {{ item.content }}
          </p>
        </template>
      </UAccordion>
    </div>
  </section>
</template>
